// Multi-tenant work packages keep their i18n keys in one file each (src/i18n/mt/<package>.ts) so that
// packages developed in parallel never edit the same line of index.ts. Merged into every language below.
import * as docprefix from './docprefix';
import * as bizcal from './bizcal';
import * as firmcontact from './firmcontact';
import * as bankscan from './bankscan';
import * as modpolicy from './modpolicy';
import * as teamcal from './teamcal';
import * as ctrlplane from './ctrlplane';
import * as dialcode from './dialcode';
import * as cpacklegal from './cpacklegal';
import * as cpackdocs from './cpackdocs';
import * as people from './people';
import * as money from './money';
import * as reqdocs from './reqdocs';
import * as zone from './zone';
import * as world from './world';
import * as invoice from './invoice';
import * as approvals from './approvals';
import * as monthlyflag from './monthlyflag';
import * as proptax from './proptax';
import * as popups from './popups';
import * as curwords from './curwords';
import * as portalintl from './portalintl';
import * as consultcal from './consultcal';
import * as acctws from './acctws';
import * as jobrestore from './jobrestore';
import * as apppack from './apppack';
import * as release from './release';
const ALL = [docprefix, bizcal, firmcontact, bankscan, modpolicy, teamcal, ctrlplane, dialcode, cpacklegal, cpackdocs, people, money, reqdocs, zone, world, invoice, approvals, monthlyflag, proptax, popups, curwords, portalintl, consultcal, acctws, jobrestore, apppack, release];
const merge = (lang: 'en' | 'zh' | 'th'): Record<string, string> => Object.assign({}, ...ALL.map(m => m[lang]));
export const mtEn = merge('en');
export const mtZh = merge('zh');
export const mtTh = merge('th');
